import { useLottie, LottieOptions } from 'lottie-react'
import { CSSProperties } from 'react'
import spinnerAnimation from '../../config/lottie/loader.json'

interface Props {
  style?: CSSProperties
}

const LottieSpinner = ({ style }: Props) => {
  const options = {
    animationData: spinnerAnimation,
    loop: true,
  } as LottieOptions

  const { View } = useLottie(options, style)

  return <>{View}</>
}

export default LottieSpinner
